export default __webpack_public_path__ + "static/agnes@2x-f86b9e6b8ae636d7d930d85843168d07.png";